export function initGuestGroupForms() {
    document.querySelectorAll('[data-guest-group-form]').forEach(form => {
        const passes = form.elements.passes_allowed;
        const name = form.elements.display_name;
        const first = form.elements.first_name;
        const last = form.elements.last_name;
        if (passes.disabled) return;
        const dependentFields = form.querySelectorAll('[data-passes-dependent]');
        let customName = Number(passes.value) === 1 ? '' : name.value;
        let wasSingle = Number(passes.value) === 1;
        const update = () => {
            const count = Number(passes.value);
            const valid = Number.isInteger(count) && count >= 1 && count <= 2147483647;
            dependentFields.forEach(field => { field.disabled = !valid; });
            name.disabled = !valid || count === 1;
            if (!valid) return;
            const single = count === 1;
            if (single) {
                if (!wasSingle) customName = name.value;
                name.value = `${first.value.trim()} ${last.value.trim()}`.trim();
            } else if (wasSingle) {
                name.value = customName;
            }
            name.readOnly = single;
            name.required = !single;
            wasSingle = single;
        };
        [passes, first, last].forEach(input => input.addEventListener('input', update));
        update();
    });
}
